export default __webpack_public_path__ + "76a1fbb.png";